import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { Store } from '@ngrx/store';
import { tap, filter, take, switchMap, catchError, withLatestFrom } from 'rxjs/operators';

import * as fromStore from '../store';
import { of } from 'rxjs';
import { SetMenuTheme } from 'src/app/store';

export const NewsOverviewGuard: CanActivateFn = route => {
  const store = inject(Store);
  return store
    .select(fromStore.getNewsOverviewLoaded)
    .pipe(
      withLatestFrom(store.select(fromStore.getNewsPage), store.select(fromStore.getNewsOverviewLoading)),
      tap(([loaded, page, loading]) => {
        const currentPage = +route.queryParams['nieuws'] || 0;
        //const filter = +route.data['filter'] || 1;

        store.dispatch(SetMenuTheme('secondary'));

        if ((!loaded || currentPage !== page.currentPage) && !loading) {
          store.dispatch(
            fromStore.LoadNewsOverview({
              skip: currentPage * page.pageSize,
              take: page.pageSize,
            })
          );
        }
      }),
      filter(([loaded]) => !!loaded),
      take(1)
    )
    .pipe(
      switchMap(() => of(true)),
      catchError(() => of(false))
    );
};
